import { FC } from 'react';
import Section from '~/components/core/section/section';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { BaseModuleProps } from './module-factory';
import ServiceUpgrade from '~/components/core/switcher/service-upgrade';
import { P2GGrid } from '@parcel2go/core-ui';

const ServiceUpgradeModule: FC<BaseModuleProps> = ({ wrapper }) => {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);

  return wrapper(
    <Section title={t('SERVICE_UPGRADE_TITLE', { defaultValue: 'Upgrades' })} dataTestId="service-upgrade-section">
      <ServiceUpgrade
        wrapper={(x) => (
          <P2GGrid container direction="column" spacing={2}>
            {x}
          </P2GGrid>
        )}
      />
    </Section>
  );
};
export default ServiceUpgradeModule;
